import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

import { ErrorService } from '@shared/services/error.service';

const LANDPAGE_ROUTE = 'landpage';

export const errorGuard: CanActivateFn = (route, state) => {
    const errorService = inject(ErrorService);
    const router = inject(Router)
    const activatedRoute = inject(ActivatedRoute);

    if (errorService.hasError()) {
        return true
    }

    router.navigate([LANDPAGE_ROUTE], { relativeTo: activatedRoute.parent });
    return false;
};
